import { Landmark, Building2, Building, Factory, HardHat, Mountain } from "lucide-react";

export const PARTNER_ICONS = {
  landmark: Landmark,
  building2: Building2,
  building: Building,
  factory: Factory,
  hardhat: HardHat,
  mountain: Mountain,
};

export const STATIC_PARTNERS = [
  { id: "farhang", icon: "landmark", name: "شركة فرهنك", tag: "بغداد — الدرجة الثالثة" },
  { id: "fikrat", icon: "building2", name: "شركة فكرة بغداد", tag: "كركوك — الدرجة الثانية" },
  { id: "ain-kirkuk", icon: "building", name: "شركة عين كركوك", tag: "كركوك — الدرجة الثانية" },
  { id: "pawl", icon: "factory", name: "شركة باول", tag: "كركوك — الدرجة الأولى" },
  { id: "shaman", icon: "hardhat", name: "شركة شامان", tag: "كركوك — الدرجة الأولى" },
  { id: "shakio", icon: "mountain", name: "شركة شاكيو", tag: "السليمانية — الدرجة الأولى" },
];
